import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdHocInstructionsGridDTO } from 'src/app/core/Dtos/ad-hoc/instructions-grid-dto';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { AdHocInstructionsService } from 'src/app/core/services/ad-hoc-instructions.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { BaseComponent } from '../../base-component';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { OktaService } from '@engie-group/ngx-gem-spaas';

@Component({
    selector: 'app-adhoc-dashboard',
    templateUrl: './adhoc-dashboard.component.html',
    styleUrl: './adhoc-dashboard.component.scss',
    standalone: false
})
export class AdhocDashboardComponent extends BaseComponent{
  @Output() 
  public OnViewInstruction : EventEmitter<string | number> = new EventEmitter<string | number>();

  public SearchCurrentAndFuture: string = "ShowActiveAndFutrure";
  public SearchDateFrom: Date = new Date();
  public SearchDateTo: Date = new Date();

  public AssetDescription: string = "";
  public AdHocData: AdHocInstructionsGridDTO[] = [];
  public AdHocLastRefresh: string = "";

  public Asset: Assets;
  private _addNewRoute: string = "";

  constructor(
    dateFormatHelper: DateFormatHelperService,
    oktaService: OktaService,
    alertService: AlertsService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _adHocService: AdHocInstructionsService) {
      super(oktaService, alertService, dateFormatHelper);
    // Load Instructions
    this.Asset = Assets.FirstHydro;
    this.SearchDateFrom.setMonth(this.SearchDateFrom.getMonth() - 1);

    switch (_activatedRoute.snapshot.routeConfig?.path) {
      case "moweo":
        this.Asset = Assets.MorayEast;
        this.AssetDescription = "Moray East";
        this._addNewRoute = "moweo/adhoc-new";
        this.UserData.IsReadOnly = this.UserData.IsReadOnly || !this.UserData.HasMorayEastAccess;
        break;
      case "fhc":
        this.Asset = Assets.FirstHydro;
        this.AssetDescription = "First Hydro";
        this._addNewRoute = "fhc/adhoc-new";
        this.UserData.IsReadOnly = this.UserData.IsReadOnly || !this.UserData.HasFHCAccess;
        break;
      case "retail":
        this.Asset = Assets.Retail;
        this.AssetDescription = "Retail";
        this._addNewRoute = "retail/adhoc-new";
        this.UserData.IsReadOnly = this.UserData.IsReadOnly || !this.UserData.HasRetailAccess;

        break;
    }
    
    this.GetInstructions();
  }

  public GetInstructions() {
    if (this.SearchCurrentAndFuture == "ShowActiveAndFutrure") {
      this._adHocService.GetActiveAndFutureInstructions(this.Asset).subscribe(
        resp => {
          this.AdHocData = resp;
        }
      );
    }
    else {
      this._adHocService.GetInstructionsByDateRange(this.Asset, this.SearchDateFrom, this.SearchDateTo).subscribe(
        resp => {
          this.AdHocData = resp;
        }
      );
    }
  }

  public SetDateTo(target: any) {
    this.SearchDateTo = target.valueAsDate;
  }
  public SetDateFrom(target: any) {
    this.SearchDateFrom = target.valueAsDate;
  }

  public AddNewAdHocInstruction() {
    this._router.navigate([this._addNewRoute]);
  }

  public ViewInstruction(instructionId: string | number) {
    this.OnViewInstruction?.next(instructionId);
  }
}
